module.exports = __webpack_public_path__ + "static/media/camera.bc267e68.svg";